import React, { Component } from 'react';
import Main from './ej2marcajeweb/Main'
import {titulo} from  './ej2marcajeweb/Configuracion'

import { createStore, combineReducers, applyMiddleware} from 'redux'
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import globalReducer from './ej2marcajeweb/redux/reducers'
import DocumentTitle from 'react-document-title'


const globalCombinedReducer = combineReducers(globalReducer);
const store = createStore(globalCombinedReducer, applyMiddleware(thunk));


class App extends Component {
  render() {
    return (
        <DocumentTitle title={titulo}>
          <Provider store={store}>
            <Main/>
          </Provider>
        </DocumentTitle>
    );
  }
}

export default App;
